// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.get-app-link{width:400px}.get-app-link__form{margin-top:20px}`, "",{"version":3,"sources":["webpack://./src/modals/GetAppLink/style.scss"],"names":[],"mappings":"AACA,cACE,WAAA,CAEA,oBACE,eAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
